"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6860],{

/***/ 36860:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(96856)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function(k) {
            if (k !== "default") {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function get() {
                        return e[k];
                    }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/ _interopNamespace(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for(var i = 0, l = from.length, ar; i < l; i++){
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var genSize = function genSize(size) {
    switch(size){
        case "2xl":
            return "w-32 h-32";
        //512x512
        case "xl":
            return "w-16 h-16";
        //64x64
        case "lg":
            return "w-8 h-8";
        //32x32
        case "md":
            return "w-5 h-5";
        //20x20
        case "sm":
            return "w-4 h-4";
        //16x16
        case "xxs":
            return "w-2 h-2";
        //8x8
        case "xs":
        default:
            //Default must be the last
            return "w-3 h-3";
    }
};
var IconRenderer = function IconRenderer(_a) {
    var IconComponent = _a.IconComponent, _b = _a.size, size = _b === void 0 ? "md" : _b, color = _a.color, loadingStyle = _a.loadingStyle, className = _a.className, rest = __rest(_a, [
        "IconComponent",
        "size",
        "color",
        "loadingStyle",
        "className"
    ]);
    var sizeClass = size && genSize(size);
    var colorStyle = color ? {
        fill: color
    } : {};
    var loadingClass = loadingStyle && "animate-".concat(loadingStyle);
    return /*#__PURE__*/ React__default["default"].createElement(IconComponent, _extends({
        style: colorStyle,
        className: "".concat(color ? color : "fill-current", " ").concat(sizeClass ? sizeClass : "", " ").concat(loadingClass ? loadingClass : "", " ").concat(className ? className : "")
    }, rest));
};
var BaseInputLabel = "font-body text-xs py-1 font-normal tracking-lg uppercase text-input";
var genClasses$1 = function genClasses(className) {
    return "".concat(!!className ? className : "", " ").concat(BaseInputLabel);
};
var InputLabel = function InputLabel(_a) {
    var htmlFor = _a.htmlFor, id = _a.id, className = _a.className, IconComponent = _a.IconComponent, iconColor = _a.iconColor, asterisk = _a.asterisk, onClickIcon = _a.onClickIcon, children = _a.children, rest = __rest(_a, [
        "htmlFor",
        "id",
        "className",
        "IconComponent",
        "iconColor",
        "asterisk",
        "onClickIcon",
        "children"
    ]);
    return /*#__PURE__*/ React__default["default"].createElement("label", _extends({
        id: id,
        className: genClasses$1(className),
        htmlFor: htmlFor
    }, rest), children, IconComponent && /*#__PURE__*/ React__default["default"].createElement(IconRenderer, {
        IconComponent: IconComponent,
        color: iconColor,
        className: "inline-block ml-1",
        onClick: onClickIcon
    }), asterisk && /*#__PURE__*/ React__default["default"].createElement("span", {
        className: "text-error text-sm ml-1 relative top-0.5"
    }, "*"));
};
var SvgArrowDown = function SvgArrowDown(props) {
    return /*#__PURE__*/ React__namespace.createElement("svg", _extends({
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 64 37"
    }, props), /*#__PURE__*/ React__namespace.createElement("path", {
        d: "M32 36.48l-32-32L4.48 0 32 27.52 59.52 0 64 4.48l-32 32z"
    }));
};
var TagRenderer = function TagRenderer(_a) {
    var children = _a.children, textTag = _a.textTag, rest = __rest(_a, [
        "children",
        "textTag"
    ]);
    if (typeof textTag === "string") {
        switch(textTag){
            case "h1":
                return /*#__PURE__*/ React__default["default"].createElement("h1", rest, children);
            case "h2":
                return /*#__PURE__*/ React__default["default"].createElement("h2", rest, children);
            case "h3":
                return /*#__PURE__*/ React__default["default"].createElement("h3", rest, children);
            case "h4":
                return /*#__PURE__*/ React__default["default"].createElement("h4", rest, children);
            case "h5":
                return /*#__PURE__*/ React__default["default"].createElement("h5", rest, children);
            case "h6":
                return /*#__PURE__*/ React__default["default"].createElement("h6", rest, children);
            case "span":
                return /*#__PURE__*/ React__default["default"].createElement("span", rest, children);
            case "p":
            default:
                return /*#__PURE__*/ React__default["default"].createElement("p", rest, children);
        }
    }
    return /*#__PURE__*/ React__default["default"].createElement("p", rest, children);
};
var Heading5 = function Heading5(_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, variant = _a.variant, children = _a.children, _c = _a.textTag, textTag = _c === void 0 ? "h5" : _c, rest = __rest(_a, [
        "className",
        "variant",
        "children",
        "textTag"
    ]);
    return /*#__PURE__*/ React__default["default"].createElement(TagRenderer, _extends({
        textTag: textTag,
        className: "".concat(className, " h5").concat(!!variant ? "-".concat(variant) : "")
    }, rest), children);
};
var SvgRadioFilled = function SvgRadioFilled(props) {
    return /*#__PURE__*/ React__namespace.createElement("svg", _extends({
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 64 64"
    }, props), /*#__PURE__*/ React__namespace.createElement("path", {
        d: "M52.706 32c0 11.435-9.27 20.706-20.706 20.706S11.294 43.436 11.294 32 20.564 11.294 32 11.294c11.435 0 20.706 9.27 20.706 20.706z"
    }), /*#__PURE__*/ React__namespace.createElement("path", {
        fillRule: "evenodd",
        d: "M32 64c17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32zm0-1c17.12 0 31-13.88 31-31C63 14.88 49.12 1 32 1 14.88 1 1 14.88 1 32c0 17.12 13.88 31 31 31z",
        clipRule: "evenodd"
    }));
};
var RadioInputClassNames = "inline-flex text-md font-normal align-middle rounded-full border border-input text-primary-dark appearance-none w-4 h-4 focus:outline-none ";
var RadioInput = function RadioInput(_a) {
    var id = _a.id, radioRef = _a.radioRef, _b = _a.className, className = _b === void 0 ? "" : _b, name = _a.name, checked = _a.checked, _c = _a.disabled, disabled = _c === void 0 ? false : _c, label = _a.label, _d = _a.required, required = _d === void 0 ? false : _d, _e = _a.IconComponent, IconComponent = _e === void 0 ? SvgRadioFilled : _e, spacing = _a.spacing, rest = __rest(_a, [
        "id",
        "radioRef",
        "className",
        "name",
        "checked",
        "disabled",
        "label",
        "required",
        "IconComponent",
        "spacing"
    ]);
    var genClasses = function genClasses(className) {
        return "".concat(RadioInputClassNames, " ").concat(disabled ? "cursor-not-allowed" : "cursor-pointer", " mr-2 ").concat(!!className ? className : "");
    };
    var labelID = "".concat(id, "-label");
    return /*#__PURE__*/ React__default["default"].createElement("div", {
        className: "flex items-center ".concat(!!spacing ? spacing : "")
    }, /*#__PURE__*/ React__default["default"].createElement("input", _extends({
        tabIndex: 0,
        name: name,
        "aria-labelledby": labelID,
        type: "radio",
        id: id,
        ref: radioRef || undefined,
        checked: checked,
        disabled: disabled,
        required: required,
        className: genClasses(className)
    }, rest)), IconComponent === SvgRadioFilled ? /*#__PURE__*/ React__default["default"].createElement(IconRenderer, {
        IconComponent: SvgRadioFilled,
        size: "sm",
        className: "hidden rounded-full bg-white border border-primary mr-2"
    }) : /*#__PURE__*/ React__default["default"].createElement("div", {
        className: "hidden justify-center items-center w-5 h-5 rounded-xl text-3xs mr-2 bg-primary"
    }, /*#__PURE__*/ React__default["default"].createElement(IconRenderer, {
        IconComponent: IconComponent,
        color: "var(--color-primary-dark)"
    })), !!label && /*#__PURE__*/ React__default["default"].createElement(InputLabel, {
        className: "my-0 sm:py-0 inline cursor-pointer",
        htmlFor: id,
        id: labelID
    }, typeof label === "string" ? /*#__PURE__*/ React__default["default"].createElement(Heading5, {
        variant: "light",
        className: "cursor-pointer"
    }, label) : label));
};
var randomString = function randomString(length) {
    if (length === void 0) {
        length = 28;
    }
    var result = [];
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for(var i = 0; i < length; i++){
        result.push(characters.charAt(Math.floor(Math.random() * charactersLength)));
    }
    return result.join("");
};
var Panel = function Panel(_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    _a.defaultOpen;
    var children = _a.children, _d = _a.header, header = _d === void 0 ? "" : _d, _e = _a.price, price = _e === void 0 ? "" : _e, _f = _a.id, id = _f === void 0 ? "" : _f, _g = _a.radio, radio = _g === void 0 ? true : _g, _h = _a.isActive, isActive = _h === void 0 ? false : _h, _j = _a.active, active = _j === void 0 ? undefined : _j, expandIcon = _a.expandIcon, _k = _a.onExpandCollapse, onExpandCollapse = _k === void 0 ? function onExpandCollapse() {} : _k, _l = _a.onChange, onChange = _l === void 0 ? function onChange() {} : _l, _m = _a.onRadioActive, onRadioActive = _m === void 0 ? function onRadioActive() {} : _m, _o = _a.required, required = _o === void 0 ? radio : _o, _p = _a.name, name = _p === void 0 ? "" : _p, _q = _a.activeRadio, activeRadio = _q === void 0 ? false : _q, _r = _a.checked, checked = _r === void 0 ? false : _r, _s = _a.disabled, disabled = _s === void 0 ? false : _s, _t = _a.IconComponent, IconComponent = _t === void 0 ? SvgArrowDown : _t, expandedIconId = _a.expandedIconId, _u = _a.iconSize, iconSize = _u === void 0 ? "xs" : _u, _v = _a.iconColor, iconColor = _v === void 0 ? "" : _v, _w = _a.index, index = _w === void 0 ? 0 : _w, _x = _a["data-testid"], dataTestId = _x === void 0 ? "" : _x, _y = _a.divider, divider = _y === void 0 ? true : _y, _z = _a.sectionId, sectionId = _z === void 0 ? "sect-".concat(index, "-").concat(randomString()) : _z, _0 = _a.backgroundColor, backgroundColor = _0 === void 0 ? "" : _0, _1 = _a.shouldStopEventPropagation, shouldStopEventPropagation = _1 === void 0 ? true : _1, rest = __rest(_a, [
        "className",
        "defaultOpen",
        "children",
        "header",
        "price",
        "id",
        "radio",
        "isActive",
        "active",
        "expandIcon",
        "onExpandCollapse",
        "onChange",
        "onRadioActive",
        "required",
        "name",
        "activeRadio",
        "checked",
        "disabled",
        "IconComponent",
        "expandedIconId",
        "iconSize",
        "iconColor",
        "index",
        "data-testid",
        "divider",
        "sectionId",
        "backgroundColor",
        "shouldStopEventPropagation"
    ]);
    var toggleState = function toggleState(forcedValue) {
        var newState = forcedValue !== undefined ? forcedValue : !isActive;
        onExpandCollapse(newState);
        if (typeof onChange === "function") {
            onChange(newState);
        }
    };
    var StopPropagation = function StopPropagation(e, preventDefault) {
        var _$_a, _b;
        if (preventDefault !== false) {
            try {
                (_$_a = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _$_a === void 0 ? void 0 : _$_a.call(e);
            } catch (e1) {}
        }
        try {
            (_b = e === null || e === void 0 ? void 0 : e.stopPropagation) === null || _b === void 0 ? void 0 : _b.call(e);
        } catch (e2) {}
    };
    var defaultPreventer = function defaultPreventer(e) {
        return StopPropagation(e, false);
    };
    var eventStoppers = shouldStopEventPropagation && {
        onClick: StopPropagation,
        onKeyDown: defaultPreventer,
        onKeyPress: defaultPreventer,
        onKeyUp: defaultPreventer
    };
    var computedActive = active !== undefined ? active : isActive;
    var radioHandlers = {
        onClick: function onClick(e) {
            if (disabled === true) {
                return;
            }
            if (!!activeRadio) {
                onRadioActive(index);
            } else {
                if (_instanceof(document.activeElement, HTMLElement)) {
                    document.activeElement.blur();
                }
                toggleState(!computedActive);
            }
            StopPropagation(e, false);
        }
    };
    var expandCollapseHandlers = {
        onClick: function onClick(e) {
            toggleState(!computedActive);
            shouldStopEventPropagation && StopPropagation(e, false);
        },
        onKeyDown: function onKeyDown(e) {
            if (disabled === true) {
                return;
            }
            (e === null || e === void 0 ? void 0 : e.keyCode) === 37 && toggleState(false); // left key
            (e === null || e === void 0 ? void 0 : e.keyCode) === 39 && toggleState(true); // right key
        }
    };
    var py = "".concat(className).match(/py-([0-9]+)/gi) ? "" : "py-3";
    var divHandlers = !!radio ? radioHandlers : expandCollapseHandlers;
    var labelId = "".concat(id || randomString(), "-labelId");
    return /*#__PURE__*/ React__default["default"].createElement("div", {
        id: "".concat(id, "_main_div"),
        role: "link",
        className: "group ".concat(divider && "border-solid border-b"),
        "aria-controls": sectionId,
        "data-testid": dataTestId,
        "aria-labelledby": labelId
    }, /*#__PURE__*/ React__default["default"].createElement("div", _extends({}, divHandlers, {
        className: "".concat(className || "", " ").concat(py, " mr-1 flex relative cursor-pointer items-center content-start text-left\n        ").concat(backgroundColor ? "".concat(backgroundColor) : "bg-white")
    }), radio === true && /*#__PURE__*/ React__default["default"].createElement(RadioInput, {
        id: "".concat(id, "_radio"),
        "aria-labelledby": labelId,
        name: name,
        required: required,
        checked: checked,
        disabled: disabled === true,
        onChange: function onChange() {},
        className: "cursor-pointer font-normal mr-2 align-middle form-radio border border-primary text-primary-dark"
    }), /*#__PURE__*/ React__default["default"].isValidElement(header) ? header : !!header && typeof header === "string" ? /*#__PURE__*/ React__default["default"].createElement(InputLabel, _extends({
        className: "items-center h-auto pt-2 cursor-pointer",
        htmlFor: id
    }, radio === true ? radioHandlers : expandCollapseHandlers), /*#__PURE__*/ React__default["default"].createElement(Heading5, {
        id: labelId
    }, header)) : null, price && /*#__PURE__*/ React__default["default"].createElement(InputLabel, {
        className: "float-right ml-auto mr-4 cursor-pointer "
    }, /*#__PURE__*/ React__default["default"].createElement(Heading5, null, price)), !!IconComponent || !!expandIcon ? /*#__PURE__*/ React__default["default"].createElement("div", {
        className: "float-right ease-out h-8 w-8 bg-transparent relative ".concat(!price && "ml-auto", " ").concat(!!disabled && "cursor-not-allowed")
    }, /*#__PURE__*/ React__default["default"].createElement("button", _extends({
        type: "button",
        "aria-expanded": computedActive,
        "aria-label": "".concat(!computedActive ? "Expand options" : "Collapse options"),
        className: "absolute transition duration-200 right-0.5 transform -translate-y-1/2 top-1/2 focus:outline-accent\n              ".concat(computedActive ? "transform -rotate-180" : "")
    }, __assign(__assign({}, expandCollapseHandlers), {
        onClick: function onClick(e) {
            e.stopPropagation();
            expandCollapseHandlers.onClick(e);
        }
    })), !!expandIcon ? expandIcon : /*#__PURE__*/ React__default["default"].createElement(IconRenderer, {
        IconComponent: computedActive && expandedIconId ? expandedIconId : IconComponent,
        color: iconColor,
        size: iconSize || "xs"
    }))) : null), /*#__PURE__*/ React__default["default"].createElement("div", _extends({}, eventStoppers, rest, {
        id: sectionId,
        role: "region",
        className: "items-start content-start text-left background-white overflow-hidden transition-all ".concat(computedActive ? "" : "hidden")
    }), !computedActive ? null : children));
};
var AccordionClassNames = "text-md font-normal";
var genClasses = function genClasses(className) {
    return "".concat(AccordionClassNames, " ").concat(!!className ? className : "");
};
var Accordion = function Accordion(_a) {
    /*  Accordion receives a list of Panel children: <Accordion><Panel /> <Panel /> </Accordion> for two panel Accordion.
    activePanel: Optional property, array of panels that are “active”. So if the first and the third panels are open then it would be [0,2].
    onChange: Radio return array of active Panels indexes
    radio: bool to show if there is a radio select on the panels, individual Panels prop take priority over Accordion prop
    disabled: Disable all user interactions over all Panels of the accordion
    IconComponent:     OPTIONAL!,  and primary Icon from DLS to display as right Icon
    iconSize:   OPTIONAL!,  Used with IconComponent to define icon size, default is md
    expandIcon: OPTIONAL!,  Right pointing Icon, <Icon/> component of the expand Icon; this can be left blank if no icon needs to be shown.
    className: just in case there is an override to className - this should usually not be used
    singleOpen: bool =true  allows for only one panel to be open at a time.
    activeRadio: Controls whether or not the radio button can be selected independently of the panel expansion
    label: aria-label={label} for the accordion div
    defaultChecked: This makes more sense to be passed individually Panel per Panel
  */ var _b;
    var _c = _a.className, className = _c === void 0 ? "" : _c, _d = _a.label, label = _d === void 0 ? "" : _d, _e = _a["aria-label"], ariaLabel = _e === void 0 ? label : _e, _f = _a.onChange, onChange = _f === void 0 ? function onChange() {} : _f, children = _a.children, _g = _a.singleOpen, singleOpen = _g === void 0 ? true : _g, _h = _a.activePanel, activePanel = _h === void 0 ? undefined : _h, _j = _a.disabled, disabled = _j === void 0 ? false : _j, _k = _a.required, required = _k === void 0 ? undefined : _k, radio = _a.radio, _l = _a.activeRadio, activeRadio = _l === void 0 ? true : _l, _m = _a.iconSize, iconSize = _m === void 0 ? "xs" : _m, expandedIconId = _a.expandedIconId, expandIcon = _a.expandIcon, _o = _a.iconColor, iconColor = _o === void 0 ? "" : _o, _p = _a.backgroundColor, backgroundColor = _p === void 0 ? "" : _p, rest = __rest(_a, [
        "className",
        "label",
        "aria-label",
        "onChange",
        "children",
        "singleOpen",
        "activePanel",
        "disabled",
        "required",
        "radio",
        "activeRadio",
        "iconSize",
        "expandedIconId",
        "expandIcon",
        "iconColor",
        "backgroundColor"
    ]);
    var _q = __read(React.useState(singleOpen !== true ? [] : null), 2), openIndex = _q[0], setOpenIndex = _q[1];
    var _r = __read(React.useState(null), 2), radioActive = _r[0], setRadioActive = _r[1];
    React.useEffect(function() {
        return setRadioActive(activeRadio);
    }, [
        activeRadio
    ]);
    var childrenLength = Object.assign([], children).length;
    var computedOpenIndex = !!activePanel && Array.isArray(activePanel) ? singleOpen === true ? (_b = activePanel.filter(function(i) {
        return i < childrenLength;
    }).slice(-1)) === null || _b === void 0 ? void 0 : _b[0] // gets the last element
     : Array.apply(null, new Array(childrenLength)).map(function(e, index) {
        return activePanel.indexOf(index) >= 0;
    }) : openIndex;
    var childrenArray = React.Children.toArray(children);
    React.useEffect(function() {
        var childrenArray = React.Children.toArray(children);
        if (singleOpen !== true) {
            setOpenIndex(childrenArray.map(function(c) {
                var _$_a;
                return ((_$_a = c === null || c === void 0 ? void 0 : c.props) === null || _$_a === void 0 ? void 0 : _$_a.defaultOpen) === true;
            }));
        } else {
            setOpenIndex(childrenArray.map(function(child) {
                var defaultOpen = child.props.defaultOpen;
                return defaultOpen === true;
            }).lastIndexOf(true));
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // This prevents from running on componentDidUpdate
    return /*#__PURE__*/ React__default["default"].createElement("div", _extends({
        "aria-label": ariaLabel || "Accordion section",
        role: radio === true ? "radiogroup" : "",
        className: genClasses(className)
    }, rest), childrenArray.map(function(child, index) {
        var _$_a = child.props, childRadio = _$_a.radio, childExpandIcon = _$_a.expandIcon, childDisabled = _$_a.disabled, childIconId = _$_a.IconComponent, childExpandedIconId = _$_a.expandedIconId, childIconSize = _$_a.iconSize, childIconColor = _$_a.iconColor, childBackgroundColor = _$_a.backgroundColor, rest = __rest(_$_a, [
            "radio",
            "expandIcon",
            "disabled",
            "IconComponent",
            "expandedIconId",
            "iconSize",
            "iconColor",
            "backgroundColor"
        ]);
        var isActive = singleOpen !== true ? (computedOpenIndex === null || computedOpenIndex === void 0 ? void 0 : computedOpenIndex[index]) === true : computedOpenIndex === index;
        return /*#__PURE__*/ React__default["default"].createElement(Panel, _extends({
            checked: radioActive === index,
            activeRadio: activeRadio,
            IconComponent: childIconId,
            expandedIconId: childExpandedIconId || expandedIconId,
            iconSize: childIconSize || iconSize,
            iconColor: childIconColor || iconColor,
            backgroundColor: childBackgroundColor || backgroundColor,
            required: required,
            expandIcon: childExpandIcon || expandIcon || null,
            index: index,
            key: "Panel-".concat(index),
            radio: radio !== undefined ? radio : childRadio,
            isActive: isActive,
            disabled: disabled || childDisabled,
            onRadioActive: function onRadioActive(index) {
                var newState = radioActive === index ? null : index;
                setRadioActive(newState);
                !disabled && onChange(newState);
            },
            onExpandCollapse: function onExpandCollapse(active) {
                if (disabled === true || childDisabled === true) {
                    return;
                }
                var newOpenAccordions = openIndex;
                if (!singleOpen) {
                    newOpenAccordions = computedOpenIndex === null ? [] : __spreadArray([], __read(computedOpenIndex || []), false);
                    newOpenAccordions[index] = active;
                    setOpenIndex(newOpenAccordions);
                } else {
                    if (active === true) {
                        newOpenAccordions = index;
                        setOpenIndex(index);
                    } else if (index === computedOpenIndex) {
                        newOpenAccordions = null;
                        setOpenIndex(null);
                    }
                }
                if (!radio && typeof onChange === "function") {
                    onChange(newOpenAccordions);
                }
            }
        }, rest));
    }));
};
exports.Accordion = Accordion;
exports["default"] = Accordion; //# sourceMappingURL=Accordion.js.map


/***/ })

}]);